import { memo, useEffect, useState } from "react";
import { searchEmailTokenMap } from "../../../repositories/emailTokenMapRepo";
import { getTicketsByIds, PER_PAGE } from "../../../repositories/ticketRepo";
import Button from "../../atoms/button/Button";
import useAuthContext from "../../context/AuthContext";
import Pagination from "./Pagination";
import TicketList from "./TicketList";

const Search = memo(() => {

  const {currentShop} = useAuthContext()
  const [searchText, setSearchText] = useState('');
  const [tokenMaps, setTokenMaps] = useState([])
  const [tickets, setTickets] = useState([])
  const [offsetStart, setOffsetStart] = useState(0);
  const [currentTickets, setCurrentTickets] = useState([])
  const [pageCount, setPageCount] = useState(Math.ceil((tickets?.length || 0) / PER_PAGE));
  const pageChange = (event) => {
    const newOffsetStart = (event.selected * PER_PAGE) % (tickets?.length || 1);
    setOffsetStart(newOffsetStart);
  }

  const onChange = (e) => {
    setSearchText(e.target.value)
  }
  const onClickSearch = () => {
    searchEmailTokenMap(currentShop?.id, searchText).then((tokenMaps) => {
      setTokenMaps(tokenMaps)
    })
  }

  useEffect(() => {
    const ticketIds = tokenMaps.map((tokenMap) => tokenMap.ticketId)
    if (!currentShop?.id || !ticketIds || !ticketIds.length) {
      setTickets([])
    }
    getTicketsByIds(currentShop?.id, ticketIds).then((tickets) => {
      setTickets(tickets)
    })
  }, [currentShop?.id, tokenMaps]);

  return (
    <div>
      <h2 className="text-5xl mb-14 mt-20">完了したお問い合せの検索</h2>
      <p className="mt-20 mb-10">
        <input
          className="w-3/12 border bg-white rounded text-xl p-2"
          type="text"
          value={searchText}
          onChange={onChange}
        />
        <Button className={'ml-5'} onClick={onClickSearch}>検索</Button>
      </p>
      <div className="drop-shadow">
        <TicketList currentTickets={tickets} />
        <Pagination
          offsetStart={offsetStart}
          currentLength={currentTickets?.length}
          maxLength={tickets?.length}
          pageCount={pageCount}
          pageChange={pageChange}
        />
      </div>
    </div>
  );
});

export default Search;
